import { cn } from "utils";
import { Fragment } from "react";
import { VirtualList, VirtualListProps } from "@ospweb/sdk-ui";
import { TableCell } from "./TableCell";

interface ColumnConfig {
  key: string;
  header: {
    label: string;
    className?: string;
  };
  attributes: (item: any) => React.HTMLAttributes<HTMLDivElement>;
}

export interface TableProps extends VirtualListProps {
  columns: ColumnConfig[];
  data?: any[];
  className?: string;
}
export const Table = (params: TableProps) => {
  const {
    className,
    columns,
    data,
    onEndReachedThreshold,
    noMoreContainerClassName,
    hasNextPage,
    onEndReached,
    renderLoading,
    renderNoMore,
  } = params;
  if (!Array.isArray(data) || !data.length) {
    return null;
  }
  return (
    <VirtualList
      className={cn(
        "w-full gap-px grid bg-border_solid no-scrollbar w-full overflow-x-hidden",
        className,
      )}
      onEndReachedThreshold={onEndReachedThreshold}
      noMoreContainerClassName={noMoreContainerClassName}
      hasNextPage={hasNextPage}
      onEndReached={onEndReached}
      renderLoading={renderLoading}
      loadingContainerClassName="bg-background_solid_secondary col-span-3 -mt-px"
      renderNoMore={renderNoMore}
      refreshContainerClassName="hidden"
    >
      {columns.map((column) => (
        <TableCell
          key={`header.${column.header.label}`}
          className={cn(
            "h-10 relative",
            "body_medium_s text-content_secondary",
            column.header.className,
          )}
        >
          {column.header.label}
        </TableCell>
      ))}
      {data.map((item, index) => {
        return (
          <Fragment key={index}>
            {columns.map((column) => (
              <TableCell
                key={`cell.${column.key}`}
                {...column.attributes(item)}
              />
            ))}
          </Fragment>
        );
      })}
    </VirtualList>
  );
};
